
    <div class="ModalContainer"
      (click)="$event.stopPropagation()"
      [attr.data-size]="size"
    >
      <fl-icon class="CloseButton"
        *ngIf="!hideCloseButton"
        [name]="'ui-close'"
        [size]="IconSize.SMALL"
        (click)="handleEscape()"
      ></fl-icon>
      <ng-container #modalContent></ng-container>
    </div>
  